//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconBase from '~/components/icons/IconBase.vue';

export default {
  name: 'ObjectionIcon',
  components: {
    IconBase,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    iconData: {
      type: Object,
      default: () => {},
    },
  },
};
